import React, {useRef} from "react";
import {correctType} from "../../../utils/legalServers";
import SquadflixVideoView from "../squadflixVideoView/squadflixVideoView";
import {useSelector} from "react-redux";
import users from "../../users";
import ButtonV2 from "../../shared/button-v2/button-v2";
import {cn, isMediumScreen} from "../../../utils/utils";
import {useNavigate} from "react-router-dom";
import TmdbNotepad from "../movies/tmdbNotepad/tmdbNotepad";
import TmdbViewToggle from "../movies/tmdbViewToggle/tmdb-view-toggle";
import SpoilersPreferenceModal from "../movies/spoilers-preference-modal/spoilers-preference-modal";
import UseUserPreferences from "../../user-app-config/hooks/use-user-preferences";
import TmdbLikeItem from "../movies/tmdbLikeItem/tmdb-like-item";
import {ScrollModal} from "../../shared/scroll-modal";

import "/node_modules/flag-icons/css/flag-icons.min.css";
import './overviewCard.scss';
import {OptionButton} from "../../shared/option-button";
import useViewTMDBContent from "../hooks/useViewTMDBContent";
import useBestVideoServer from "../hooks/useBestVideoServer";

function OverviewCardV2(props) {
    const {
        imagePath,
        tagline,
        overview,
        view,
        playing,
        itemName,
        item,
        file,
        type,
        tmdbId,
        season,
        episode,
        showViewLaterButton,
        onGoNextEpisode,
        nextEpisode
    } = props;
    const darkMode = useSelector(users.selectors.isDarkMode);
    const {servers, selectedServer, setSelectedServer, usingServer} = useBestVideoServer(item, file, type);
    const navigate = useNavigate();
    const serversModalApi = useRef(null);
    const optionsModalApi = useRef(null);
    const {userPreferences, loading: loadingPreferences} = UseUserPreferences();
    const {markThingAsView} = useViewTMDBContent();

    const hideSpoilers = (userPreferences.hideSpoilers || userPreferences.hideSpoilers == null || loadingPreferences) && !view && type === 'tv';

    function showTitle() {
        return (<>
            {!hideSpoilers && <h4 className="overview-card-v2__header-title text-light mb-0">
                {item.name || item.title}
            </h4>}
            {hideSpoilers && <h4 className="overview-card-v2__header-title text-light mb-0">
                {item.serie.name} - {`S${season}:E${episode}`}
            </h4>}
        </>)
    }

    function goBackButton() {
        return (<ButtonV2
            forceDarkMode={"dark"}
            title="Volver"
            className=""
            width={"50px"}
            onClick={() => {
                if (type === 'movie') {
                    navigate("..");
                } else {
                    navigate(`/squadflix/series/${tmdbId}`);
                }
            }}>
            <i className={cn("fa-solid fa-chevron-left fa-lg")}></i>
        </ButtonV2>);
    }

    return (

        <div className="overview-card-v2" style={{
            height: "100%",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundColor: "black",
        }}>
            <div className="overview-card-v2__header">
                <div className="overview-card-v2__header-left" style={{}}>
                    {goBackButton()}
                    {!isMediumScreen() && <>
                    </>}
                    {showTitle()}
                </div>
                {!isMediumScreen() &&
                    <div className="d-flex gap-2">
                        <TmdbNotepad tmdbItem={item} forceDarkMode={"dark"}/>
                        <TmdbLikeItem tmdbItem={item} forceDarkMode={"dark"}/>
                        <TmdbViewToggle item={item} forceDarkMode={"dark"}/>
                        <ButtonV2
                            forceDarkMode={"dark"}
                            onClick={() => {
                                serversModalApi.current.open();
                            }}>
                            {selectedServer}
                            {usingServer.flag && <>&nbsp;<span className={usingServer.flag}></span></>}
                            {usingServer.value === "SquadFlix" && <>&nbsp;<span>🌟</span></>}
                            {!usingServer.flag && <>&nbsp;<span>🌐</span></>}
                            <i className="fa-solid fa-sort-down ps-3"></i>
                        </ButtonV2>
                    </div>}
                {isMediumScreen() && <ButtonV2 width={50} onClick={() => {
                    optionsModalApi.current.open();
                }} forceDarkMode={"dark"} title="Detalles">
                    <i className="fa-solid fa-ellipsis-vertical fa-lg"></i>
                </ButtonV2>}
            </div>
            <div className="overview-card-v2__video-view" style={{
                height: `calc(100dvh - ${isMediumScreen() ? 185 : 94}px)`,
            }}>
                {selectedServer && <SquadflixVideoView {...props} selectedServer={selectedServer}/>}
            </div>
            {isMediumScreen() &&
                <div className="overview-card-v2__server-btn d-flex pt-3">
                    <ButtonV2
                        forceDarkMode={"dark"}
                        width={"100%"}
                        style={{
                            justifyContent: "space-between",
                        }}
                        onClick={() => {
                            serversModalApi.current.open();
                        }}>
                        <div style={{
                            width: "fit-content",
                        }}>
                            {selectedServer}
                            {usingServer.flag && <>&nbsp;<span className={usingServer.flag}></span></>}
                            {usingServer.value === "SquadFlix" && <>&nbsp;<span>🌟</span></>}
                            {!usingServer.flag && <>&nbsp;<span>🌐</span></>}
                        </div>
                        <i className="fa-solid fa-sort-down ps-3"></i>
                    </ButtonV2>
                </div>}
            {type === "tv" && <SpoilersPreferenceModal serie={item.serie}/>}
            {isMediumScreen() && <ScrollModal ref={optionsModalApi}>
                <OptionButton text="Abrir notas" icon={<i className="fa-solid fa-note-sticky fa-lg"></i>}
                              onClick={() => {
                                  navigate("#notes");
                                  optionsModalApi.current.close();
                              }}/>
                <OptionButton text={item.view ? "Marcar como no visto" : "Marcar como visto"} icon={
                    item.view
                        ? <i className="fa-solid fa-eye-slash fa-lg"></i>
                        : <i className="fa-solid fa-eye fa-lg"></i>
                } onClick={() => {
                    markThingAsView(!item.view);
                }}/>
                <OptionButton text="Añadir reseña" icon={<i className="fa-solid fa-star fa-lg"></i>}
                              onClick={() => {
                                  navigate("#add-review");
                                  optionsModalApi.current.close();
                              }}/>
                <div style={{display: "none"}}>
                    <TmdbNotepad tmdbItem={item} forceDarkMode={"dark"}/>
                    <TmdbLikeItem tmdbItem={item} forceDarkMode={"dark"}/>
                </div>
            </ScrollModal>}
            <ScrollModal ref={serversModalApi}>
                {servers.filter(x => correctType(x.value, type) && !x.disabled).map(server => {
                    return <OptionButton
                        key={server.value}
                        active={server.value === selectedServer}
                        onClick={() => {
                            setSelectedServer(server.value);
                            serversModalApi.current.close();
                        }} icon={
                        <>
                            {server.flag && <>&nbsp;<span className={server.flag}></span></>}
                            {server.value === "SquadFlix" && <>&nbsp;<span>🌟</span></>}
                            {!server.flag && <>&nbsp;<span>🌐</span></>}
                        </>
                    }>
                        {server.value}
                    </OptionButton>
                })}
            </ScrollModal>
        </div>
    );
}

export default OverviewCardV2;
